import { forwardRef, type Ref, type SVGProps } from "react";
const IconManufacturedOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M6.66 3a2 2 0 0 0-1.84 1.212l-2.143 5A2 2 0 0 0 4.517 12H5v9a2 2 0 0 0 2 2h12v2a1 1 0 1 0 2 0v-2h2v2a1 1 0 1 0 2 0v-2a2 2 0 0 0 2-2v-9h.483a2 2 0 0 0 1.839-2.788l-2.143-5A2 2 0 0 0 25.34 3zM16 21v-5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v5H7v-9h18v9zM6.66 5h18.68l2.143 5H4.517zM14 21h-3v-4h3z"
      clipRule="evenodd"
    />
    <path d="M8 25a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 2a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2z" />
  </svg>
);
const ForwardRef = forwardRef(IconManufacturedOutlineSVG);
ForwardRef.displayName = "IconManufacturedOutline";
export { ForwardRef as IconManufacturedOutline };
